import axios from "./_axios";
import { API } from "./apiEndPoints";

/**
 * Fetches account active counts (employees, positions, roles, responsibilities, procedures)
 * This API call is INDEPENDENT of any filters applied to the employee/position/role lists.
 * It should always return the total counts regardless of current filter state.
 *
 * @param {string|number} account_id - The account ID
 * @returns {Promise} Axios response with account counts data
 */
export const getAccountActiveCount = async (account_id) => {
  // Explicitly ensure no filter parameters are included
  // This call must be independent of any filters applied elsewhere
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/active-counts/`,
    params: {}, // Explicitly set empty params to ensure no filters are applied
  });
  return result;
};
